
import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeProvider';
const ThemeSwitcher = () => {
    const { theme, toggleTheme } = useTheme();
  

    return (
        <div className="flex items-center justify-center space-x-2 sm:space-x-4 flex-shrink-0">
            <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={toggleTheme}
                className="p-1.5 h-10 w-10 bg-transparent border border-gray-400 hover:border-gray-500 cursor-pointer rounded-lg transition-all duration-200 hover:shadow-sm active:scale-95"
                aria-label={`Switch to ${theme === 'light' ? 'Light' : 'Dark'} Mode`}
            >
                {theme === 'dark' ? <Sun className="w-5 h-5 stroke-1 text-yellow-500" /> : <Moon className="w-5 h-5 stroke-1 text-gray-900 dark:text-yellow-500" />}
            </motion.button>
        </div>
    );
};

export default ThemeSwitcher;
